import { useContext, useEffect, useRef } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip } from 'chart.js';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

const CHART_COLORS = ['#5CAE48', '#26A7DF', '#F3AD18', '#D42941', '#51499C', '#0B3454', '#848484'];

const OutreachByTeamChart = () => {
    const { state } = useContext(SmartContext);
    const chartRef = useRef<HTMLCanvasElement>(null);
    const chartInstanceRef = useRef<Chart | null>(null);
    const outreachByTeam = state.data.outreachByTeam;

    useEffect(() => {
        if (!chartRef.current || !outreachByTeam.labels?.length) return;

        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const ctx = chartRef.current.getContext('2d');
        if (!ctx) return;

        chartInstanceRef.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: outreachByTeam.labels.map((label: string) => getDomainValueForCode(label, 'OUTREACH_TEAM_CODE', state)),
                datasets: [
                    {
                        data: outreachByTeam.data,
                        backgroundColor: outreachByTeam.labels.map(
                            (_: string, i: number) => CHART_COLORS[i % CHART_COLORS.length]
                        ),
                        borderRadius: 4,
                        maxBarThickness: 50,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: '#0B3454',
                        titleFont: { family: 'Jost' },
                        bodyFont: { family: 'Jost' },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { font: { family: 'Jost', size: 12 }, color: '#646464' },
                    },
                    y: {
                        beginAtZero: true,
                        grid: { color: '#f0f0f0' },
                        ticks: {
                            font: { family: 'Jost', size: 12 },
                            color: '#646464',
                            stepSize: 1,
                        },
                    },
                },
            },
        });

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [outreachByTeam]);

    return (
        <div className="bg-white p-4 custom-shadow h-100 radius-6">
            <h5 className="col font-18 font-600 mb-3">Outreach by Team</h5>
            {outreachByTeam.labels?.length > 0 ? (
                <div style={{ height: '268px' }}>
                    <canvas ref={chartRef}></canvas>
                </div>
            ) : (
                <p className="font-14 text-gray-64">No team outreach data available.</p>
            )}
        </div>
    );
};

export default OutreachByTeamChart;
